import { CMS_BASE_URL } from "../config/config";

export const generateImageUrl = (image) => {
  if (!image) return;
  return CMS_BASE_URL + image.location + image.filename;
};
